var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCartIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 0C2.20435 0 1.44129 0.316071 0.87868 0.87868C0.316071 1.44129 8.88705e-08 2.20435 8.88705e-08 3V18.138C-9.03486e-05 18.4008 0.0688447 18.6589 0.199905 18.8867C0.330964 19.1144 0.51955 19.3037 0.746783 19.4357C0.974015 19.5676 1.23192 19.6376 1.49468 19.6385C1.75744 19.6394 2.01584 19.5713 2.244 19.441L7.504 16.435C7.65506 16.3487 7.82603 16.3033 8 16.3033C8.17397 16.3033 8.34494 16.3487 8.496 16.435L13.756 19.441C13.9842 19.5713 14.2426 19.6394 14.5053 19.6385C14.7681 19.6376 15.026 19.5676 15.2532 19.4357C15.4805 19.3037 15.669 19.1144 15.8001 18.8867C15.9312 18.6589 16.0001 18.4008 16 18.138V3C16 2.20435 15.6839 1.44129 15.1213 0.87868C14.5587 0.316071 13.7956 0 13 0H3Z",
    fill: "#BCBCBC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartIcon);
export default __webpack_public_path__ + "static/media/CartIcon.811c996c9979db8ec371730cdb08b7d8.svg";
export { ForwardRef as ReactComponent };